const weightUnit = {
  '1': 1000000,
  '2': 1000,
  '3': 1
};
const useWeightDeal = (unit, data) => {
  return data / weightUnit[unit];
};
export default useWeightDeal;
